import { render, staticRenderFns } from "./ContentBlock.vue?vue&type=template&id=10a3769c&scoped=true"
import script from "./ContentBlock.vue?vue&type=script&lang=js"
export * from "./ContentBlock.vue?vue&type=script&lang=js"
import style0 from "./ContentBlock.vue?vue&type=style&index=0&id=10a3769c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a3769c",
  null
  
)

export default component.exports